<div class="bootstrap-modal">
  <button
    type="button"
    class="{{ buttonClass }}"
    data-bs-toggle="modal"
    data-bs-target="#modalPopup"
  >
    {{ label }}
  </button>

  <div class="modal fade" id="modalPopup">
    <div class="modal-dialog {{ position }} {{ size }}" aria-labelledby="modalTitle" aria-describedby="modalDesc"> <!--role document kaldırııldı ek olarak class modal-dialog {{ position }} {{ size }}" kulanılabilir-->
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            *ngIf="closeButton"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <div class="body">{{ text }}</div>
          <ng-content select="[bodyContent]"></ng-content>
        </div>

        <div *ngIf="footer" class="modal-footer">
          <button
            *ngIf="cancelButton"
            type="button"
            class=" {{ cancelButtonStyle }} "
            data-bs-dismiss="modal"
          >
            {{ cancelButtonLabel }}
          </button>
          <button
            *ngIf="saveButton"
            type="button"
            class=" {{ saveButtonStyle }} "
            (click)="onClickSaveButton($event)"
          >
            {{ saveButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
